import { useQuery } from '@tanstack/react-query';
import type { ServerStatus } from '../api/types.js';
import { useApiClient } from './use-api-client.js';

export function useMetrics(serverId: string, status: ServerStatus) {
  const api = useApiClient();
  const isRunning = status === 'running';
  const isTransitioning = status === 'starting' || status === 'stopping';

  return useQuery({
    queryKey: ['metrics', serverId],
    queryFn: () => api.servers.metrics(serverId),
    enabled: isRunning || isTransitioning,
    refetchInterval: isTransitioning ? 5_000 : 30_000,
  });
}
